<form [formGroup]="otoBuySellForm">
    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
                <select [ngClass]="{ 'is-invalid': submitted && otoBuySellForm['controls'].duration.errors }"
                    class="custom-select" formControlName="duration" id="inputGroupSelect01">
                    <option selected>-Duration-</option>
                    <option *ngFor="let duration of durationOptions" [value]="duration.value">{{duration.name}}</option>
                </select>
                <span *ngIf="submitted && otoBuySellForm['controls'].duration.errors">
                    <span class="text-danger" *ngIf="otoBuySellForm['controls'].duration.errors.required">Duration
                        Is
                        Required</span>
                </span>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <input [ngClass]="{ 'is-invalid': submitted && otoBuySellForm['controls'].quantity.errors }"
                    type="number" class="form-control" formControlName="quantity" placeholder="Quantity">
                <span *ngIf="submitted && otoBuySellForm['controls'].quantity.errors">
                    <span class="text-danger" *ngIf="otoBuySellForm['controls'].quantity.errors.required">Quantity Is
                        Required</span>
                </span>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
                <select [ngClass]="{ 'is-invalid': submitted && otoBuySellForm['controls'].type.errors }"
                    class="custom-select" formControlName="type" id="inputGroupSelect01">
                    <option selected>-Type-</option>
                    <option *ngFor="let type of typeOptions" [value]="type.value">{{type.name}}</option>
                </select>
                <span *ngIf="submitted && otoBuySellForm['controls'].type.errors">
                    <span class="text-danger" *ngIf="otoBuySellForm['controls'].type.errors.required">Type Is
                        Required
                    </span>
                </span>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <input [ngClass]="{ 'is-invalid': submitted && otoBuySellForm['controls'].quantity.errors }" type="text"
                    class="form-control" formControlName="option_symbol" placeholder="Option Symbol">
                <span *ngIf="submitted && otoBuySellForm['controls'].class.errors">
                    <span class="text-danger" *ngIf="otoBuySellForm['controls'].class.errors.required">Option
                        Symbol Is
                        Required</span>
                </span>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
                <select [ngClass]="{ 'is-invalid': submitted && otoBuySellForm['controls'].side.errors }"
                    class="custom-select" formArrayName="side" id="inputGroupSelect01">
                    <option selected>-Side-</option>
                    <option *ngFor="let side of sideOptions" [value]="side.value">{{side.name}}</option>
                </select>
                <span *ngIf="submitted && otoBuySellForm['controls'].side.errors">
                    <span class="text-danger" *ngIf="otoBuySellForm['controls'].side.errors.required">Side Is
                        Required
                    </span>
                </span>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <button type="submit" [disabled]="submitInProgress" (click)="onSubmit()"
                class="btn btn-success">Submit</button>
        </div>
    </div>
    <!-- {{otoBuySellForm.value| json}} -->
</form>